import React from 'react';
import { useTranslation } from 'react-i18next';
import './YesNoButtons.css';

interface YesNoButtonsProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

const YesNoButtons: React.FC<YesNoButtonsProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="yes-no-group" role="radiogroup">
      <button
        type="button"
        role="radio"
        className={`yes-no-button ${value ? 'active' : ''}`}
        onClick={() => onChange(true)}
        aria-checked={value}
      >
        {t('form.answersSection.yes')}
      </button>
      <button
        type="button"
        role="radio"
        className={`yes-no-button ${!value ? 'active' : ''}`}
        onClick={() => onChange(false)}
        aria-checked={!value}
      >
        {t('form.answersSection.no')}
      </button>
    </div>
  );
};

export default YesNoButtons;

